import { memo, useCallback } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { Layout } from 'modules/layout'
import { buildSimulatorUrl } from 'src/utils/buildSimulatorUrl'
import { pushDataLayer } from 'utils/push-data-layer'

import Hero from './hero'
import Products from './products'

const AboutUs = dynamic(() => import('./about-us'))
const Benefits = dynamic(() => import('./benefits'))
const Help = dynamic(() => import('./help'))
const IdealCredit = dynamic(() => import('./ideal-credit'))
const Simulation = dynamic(() => import('./simulation'))
const SocialMedia = dynamic(() => import('./social-media'))
const Statistics = dynamic(() => import('./statistics'))

export const Home = memo(() => {
  const router = useRouter()

  const handleClick = useCallback(
    (clickTarget: string, label: string) => {
      pushDataLayer({
        category: 'Clique',
        action: 'Botões',
        label: `${clickTarget} - Home - ${label}`
      })

      location.href = buildSimulatorUrl(router.pathname, { medium: clickTarget + '-' + label })
    },
    [router.pathname]
  )

  return (
    <Layout>
      <Hero onClick={() => handleClick('Banner', 'Simular agora')} />
      <Products />
      <Benefits />
      <Simulation />
      <IdealCredit />
      <Statistics />
      <AboutUs />
      <SocialMedia />
      <Help />
    </Layout>
  )
})

Home.displayName = 'Home'
